export const ROLE_LABELS = {
  DATA_ENTRY: "Veri Giriş",
  REVIEWER: "Kontrol",
  ADMIN: "Yönetici",
  REPORT_VIEWER: "Rapor",
};

export const WRITE_ROLES = new Set(["DATA_ENTRY", "REVIEWER", "ADMIN"]);
export const ADMIN_ROLES = new Set(["ADMIN"]);

export function canWrite(user) {
  return user && (WRITE_ROLES.has(user.role) || user.is_superuser);
}

export function isAdmin(user) {
  return user && (ADMIN_ROLES.has(user.role) || user.is_superuser);
}

export function canViewAudit(user) {
  return user && (user.role === "REVIEWER" || user.role === "ADMIN" || user.is_superuser);
}
